import type { Promotion, SingleMembershipsPromotion } from '../Promotions.types'

export const isPromotionMembershipsSingle = (
  promotion: Promotion,
): promotion is SingleMembershipsPromotion => promotion.type === 'MEMBERSHIPS_SINGLE'
